import React from 'react'

export const HowItWorks = ({
  data,
}: {
  data: Array<{ title: string; content: string }>
}) => (
  <div className='flex flex-col justify-start items-start max-w-[651px]'>
    <h4 className='font-medium tracking-wide text-sm md:text-base'>
      How it works
    </h4>

    <hr className='w-full h-[1px] my-[16px] bg-gradient-to-r from-transparent via-[#0C3A78] to-transparent' />

    {data.map((step, index) => (
      <div
        id={step.title + index}
        className='grid grid-cols-[24px_1fr] sm:grid-cols-[40px_1fr] items-center gap-x-3 sm:gap-x-5'
      >
        <div className='flex justify-center items-center rounded-full w-6 sm:w-10 h-6 sm:h-10 bg-[#9FCDD7] text-sm sm:text-lg font-medium sm:font-bold'>
          <span>{index + 1}</span>
        </div>

        <h5 className='text-[#101828] text-sm sm:text-base font-medium tracking-wide text-left'>
          {step.title}
        </h5>

        {data.length - 1 !== index ? (
          <div className='h-full w-full flex justify-center items-center py-3'>
            <span className='h-full w-[2px] bg-[#9FCDD7]' />
          </div>
        ) : (
          <div />
        )}

        <p className='text-xs md:text-base text-justify  text-[#586885] pb-[20px] '>
          {step.content}
        </p>
      </div>
    ))}
  </div>
)
